<script>
import { Helper } from '@/mixin/helper'
import RestEditableTableV2 from '@/components/RestEditableTableV2'
import * as manufacturerApi from '@/services/rest-api-sms/lib/vehicle/vehicle-manufacturer'
import* as modelApi from '@/services/rest-api-sms/lib/vehicle/vehicle-model'
import i18n from '@/i18n'

export default {
  components: {
    RestEditableTableV2,
  },
  mixins: [Helper],
  data() {
    return {
      isTableDataAvailable: true,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    fields() {
      return [
        {
          key: 'model',
          label: i18n.t('master.list.fleetType.model'),
          placeholder: i18n.t('master.list.fleetType.model'),
          isEditable: true,
          isSortable: false,
          validation: [['required']],
          thClass: 'mc-table--500',
        },
        {
          key: 'manufacturer',
          label: i18n.t('master.list.fleetType.manufacturer'),
          placeholder: 'Pilih ' + i18n.t('master.list.fleetType.manufacturer'),
          isSortable: false,
          isEditable: true,
          type: 'select-resourceful',
          trackBy: 'manufacturer',
          optionsGetter: this.resourcefulQuery.manufacturers,
          optionLabelFn: ({ item }) => item.manufacturer,
          validation: [['required']],
          thClass: 'mc-table--500',
          thStyle: 'width: 500px',
        },
      ]
    },

    resourcefulQuery() {
      return {
        manufacturers: async (opts) => {
          const params = {
            search: opts?.search,
            page: opts?.page,
          }

          const result = await manufacturerApi.get(params)
          return result
        },
      }
    },

    apiClient() {
      return {
        get: modelApi.get,
        store: modelApi.store,
        delete: modelApi.deleteMany
      }
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    isContains(search, name) {
      const searchContains = RegExp(search ?? '', 'gi').exec(name ?? '')
      return searchContains != null && searchContains.length > 0
    },
    async handleChange() {
      const modelVehicleRef = this.$refs.modelVehicleRef.$refs
      await this.$nextTick()
      this.fields.forEach(field => {
        if (!field.isEditable) return
        modelVehicleRef[`${field.key}-ref`].$el.addEventListener('keydown', Helper.methods.preventTabKey)
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="card">
      <div class="card-body">
        <RestEditableTableV2
          ref="modelVehicleRef"
          v-show="isTableDataAvailable"
          searchable
          :fields="fields"
          :apiClient="apiClient"
          :bulkDeleteApi="true"
          :idIsString="true"
          :multiPayload="true"
          @available-change="handleDataAvailable"
          trackBy="id"
          @changeData="handleChange"
        />
      </div>
    </div>
  </div>
</template>
